type GetClampedScrollOffsetYParams = {
  offsetY: number;
  contentHeight?: number | null;
  viewportHeight?: number | null;
};

export const getClampedScrollOffsetY = ({
  offsetY,
  contentHeight,
  viewportHeight,
}: GetClampedScrollOffsetYParams): number => {
  "worklet";
  const safeContentHeight = contentHeight ?? 0;
  const safeViewportHeight = viewportHeight ?? 0;

  if (safeContentHeight <= 0 || safeViewportHeight <= 0) {
    return Math.max(0, offsetY);
  }

  const maxScrollY = Math.max(0, safeContentHeight - safeViewportHeight);

  return Math.max(0, Math.min(offsetY, maxScrollY));
};
